/**
 * The sentence shown while a run queues for an Epic session.
 *
 * v1.2's `waiting_for_service_principal` payload carries its own prose in
 * `pending_action`; v2's `lease_wait` carries none -- only a queue position --
 * so the panel composes one. Without it the generic `question` fallback reads
 * "Respond to continue", which is wrong twice over: nothing is being asked,
 * and the run resumes itself the moment a session frees.
 *
 * `ahead_count` is peers ahead of us, so 0 means next in line -- NOT "no
 * queue". Absent (a payload shape we do not recognise) says nothing about the
 * queue rather than guessing a position.
 */
export function leaseWaitMessage(q: Record<string, unknown>): string {
  const ahead = typeof q.ahead_count === "number" ? q.ahead_count : null;
  const opening =
    q.is_reacquire === true
      ? "Waiting to get back into Epic."
      : "Waiting for an Epic session.";
  const queue =
    ahead === null
      ? ""
      : ahead <= 0
        ? " Yours is next in line."
        : ahead === 1
          ? " One run is ahead of yours."
          : ` ${ahead} runs are ahead of yours.`;
  return (
    `${opening}${queue} It carries on by itself as soon as one is free — ` +
    "nothing is needed from you."
  );
}
